<template>
    <div class="page">
        <div class="main_body">
                <div class="top_label">
                    <span class="lable_name">作业管理</span>
                    
                </div>

                <div class="work_table">
                    <span @click="changeTab(0)" :class="{'active':form.worktype == 0}">周期作业</span>
                    <span @click="changeTab(1)" :class="{'active':form.worktype == 1}"> 临时作业</span>
                </div>

                <div class="work_statistics_box">
                    <div class="work_statistics_title"> 
                        <i class="el-icon-stopwatch"></i>
                        <span>学习统计</span>
                    </div>
                    
                    <div class="work_statistics">
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">作业总数</span>
                                <span class="statistics_item_left_num">{{statistics.total_task_number}} 次</span>
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon">
                                    <i class="el-icon-bell"></i>
                                </span>
                            </div>
                        </div>
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">平均成绩</span>
                       
                                <span class="statistics_item_left_num">{{statistics.average_score}} 分</span>
                       
                                
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon" style="background-color: #FDE2E2;color: #F56C6C;">
                                    <i class="el-icon-check"></i>
                                </span>
                            </div>
                        </div>
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">完成率</span>
                                <span class="statistics_item_left_num">{{statistics.complete_rate}}%</span>
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon" style="background-color: #E1F3D8;color: #67C23A;">
                                    <i class="el-icon-edit"></i>
                                </span>
                            </div>
                        </div>
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">学习时长</span>
                                <span class="statistics_item_left_num">{{statistics.total_time}}</span>
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon" style="background-color: #FDE2E2;color: #F56C6C;">
                                    <i class="el-icon-document-checked"></i>
                                </span>
                            </div>
                        </div>
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">阅读在线</span>
                                <div class="statistics_item_left_num_box">
                                    <span class="statistics_item_left_num">{{statistics.read_number}} 篇</span>
                                    <span style="color:green" class="statistics_item_left_diff">正确率 {{statistics.read_average_score}}%</span>
                                </div>
                                
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                    <i class="el-icon-monitor"></i>
                                </span>
                            </div>
                        </div>
                        <div class="statistics_item">
                            <div class="statistics_item_left">
                                <span class="statistics_item_left_title">应试英语</span>
                                <div class="statistics_item_left_num_box">
                                    <span class="statistics_item_left_num">{{statistics.specatily_number}} 篇</span>
                                    <span style="color:green" class="statistics_item_left_diff">正确率 {{statistics.specatily_average_score}}%</span>
                                </div>
                            </div>
                            <div class="statistics_item_right">
                                <span class="statistics_item_right_icon" style="background-color:#f3e8ff;color:#9333ea">
                                    <i class="el-icon-edit"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
                
                <div class="work_list">
                    <div class="work_list_title">
                        <div class="work_list_title_left">
                            <i class="el-icon-edit"></i>
                            <span>我的作业</span>
                        </div>
                        <el-input v-model="form.keyword" style="width: 300px;" :clearable="true" @input="changKeyword" placeholder="请输入作业名称">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        
                    </div>

                    <div class="work_list_box">
                        
                        <div v-for="(item,index) in list" :key="index" class="work_list_item">
                            <div class="work_list_item_title">
                                <span class="work_list_status">{{item.status == 0?'未开始':(item.status == 1?'已结束':'进行中')}}</span>
                                <span class="work_list_name">{{item.title}}</span>
                            </div>
                
                            <div class="work_list_item_content">
                                
                                <el-tag v-if="item.read_number">阅读在线 {{item.read_number}} 篇</el-tag>
                                <el-tag v-if="item.specialty_number">应试英语 {{item.specialty_number}} 篇</el-tag>
                            </div>
                            
                            <div class="work_list_item_content">
                                <i style="color: #409EFF;" class="el-icon-time"></i>
                                <span>{{item.start_time_text}} 至 {{item.end_time_text}}</span>
                            </div>
                            <div class="work_list_press">
                                <span>总篇数 {{item.total_number}} 篇</span>
                                <span style="color:#F56C6C">已完成 {{item.submitanswer_number}} 篇</span>
                            </div>
                            <div class="work_list_press_progress">
                                <el-progress :show-text="false" :percentage="item.complete_work_press"></el-progress>
                            </div>
                            <div @click="workDetail(item.id,item.title)" class="work_list_view">
                                <span>查看作业 <i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>

                    </div>
                    <el-empty v-if="!list.length" description="暂无作业信息"></el-empty>
                </div>
            </div>
    </div>
</template>
<script>
import Http from "../../apis/student";
import skeleton from "../../../untils/skeleton.vue";
export default {
    components:{
        'Skeleton':skeleton
    },
    data(){
        return{
            form:{
                keyword:'',
                page:1,
                pageSize:20,
                worktype:0
                
            },
            statistics:{},
            list:[]
        }
    },

    created(){
        this.workIndexStatistics()
        this.workList()
    },

    methods:{
        // 获取作业管理首页顶部统计
        workIndexStatistics(){

            var params = {}
            params.type = this.form.worktype
            Http.workIndexStatistics(params).then((res) => {
                this.statistics = res.data
            });

        },
        workList(){
    
            Http.workList(this.form).then((res) => {
                this.list = res.data
            });
            
        },
        // 作业
        workDetail(task_id,name){
            this.$router.push({name:'Workdetail',query:{task_id:task_id,task_name:name,worktype:this.form.worktype}});
        },
        // 切换tab
        changeTab(index){
            this.form.worktype = index
            this.workList()
            this.workIndexStatistics()
        },
        // 搜索
        changKeyword(e){
            this.form.keyword = e
            this.form.page = 1
            this.workList()
        }
    }
}
</script>

<style scoped>

.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}
.main_body >>> .el-card__body{
    float: left;
    width: 100%;
    padding-right: 25px;
    box-sizing: border-box;
}
.main_body >>> .el-col{
    margin-bottom: 20px;
}

.work_statistics{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
    
    
}

.statistics_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.statistics_item_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
}
.statistics_item_left_title{
    font-weight: 700;
}
.statistics_item_left_num{
    font-size: 14px;
    font-weight: 700;
}
.statistics_item_right_icon{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #D9ECFF;
    color: #409EFF;
}
.work_statistics_box{
    display: inline-block;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: 10px;
}
.work_statistics_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 20px;
}
.work_statistics_title span{
    font-weight: 700;
}
.work_statistics_title i{
    
    color: #409EFF;
}
.statistics_item_left_num_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
.statistics_item_left_diff{
    font-size: 12px;
}

.work_table{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    margin-top: 25px;
    padding-left: 20px;
}
.work_table span{
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    background: #fff;
    transition: all 0.3s ease;
}
.active{
    color: #fff !important;
    background: #409EFF !important;
}

.work_table span:hover{
    color: #fff;
    background: #409EFF;
}
.work_list{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 30px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
}
.work_list_title{
    display: flex;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
}
.work_list_title_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.work_list_title i{
    margin-top: 2px;
    color: #409EFF;
}
.work_list_title span{
    font-weight: 700;
}
.work_list_box{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
}
.work_list_item{
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
}
.work_list_item:hover{
    background: #fff;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
    transform: translateY(-2px);
}
.work_list_item_title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.work_list_status{
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    color: #f56c6c;
    background: #fde2e2;
}
.work_list_name{
    font-size: 16px;
    font-weight: 700;
}
.work_list_item_content{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    margin-top: 15px;
}
.work_list_press{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-top: 15px;
}
.work_list_press_progress{
    display: inline-block;
    width: 100%;
}
.work_list_view{
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    margin-top: 15px;
    color: #409EFF;
}
</style>